<template>
  <div class="panel">
    <loader :loading="loading"/>
    <div class="l-level" v-if="icon">
      <div class="l-level__left" :class="color">
        <i class="icon-3x icon" :class="icon"></i>
      </div>
      <div class="l-level__right">
        <div class="l-level__item c-count u-textRight">
          <div class="c-count__label">{{ label }}</div>
          <div class="c-count__content" v-if="typeof value === 'object'" v-bind:style="style">
            <div v-for="val in value">
              {{ val }}
            </div>
          </div>
          <div class="c-count__content" v-else v-bind:style="style">
            {{ value }}
          </div>
        </div>
      </div>
    </div>

    <div class="c-panel__body" v-else>
      <div class="l-level">
        <div class="l-level__item c-count">
          <div class="c-count__label">{{ label }}</div>
          <div class="c-count__content" v-if="typeof value === 'object'" v-bind:style="style">
            <div v-for="val in value">
              {{ val }}
            </div>
          </div>
          <div class="c-count__content" v-else v-bind:style="style">
            {{ value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loader from '@/components/template/Loader'

  export default {
    props: {
      label: {
        type: String,
        required: true
      },
      value: {
        type: [String, Array, Number],
        required: true
      },
      icon: {
        type: String,
        required: false
      },
      color: {
        type: String,
        required: false
      },
      fontSize: {
        type: String,
        default: '20px'
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data () {
      return {
        selected: false,
        style: {
          fontSize: this.fontSize
        }
      }
    },
    computed: {
      infoIcon () {
        return this.icon + ' ' + this.color
      }
    },
    components: {
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .panel
    position: relative
    min-height: 100px
    width: 100%
    -webkit-box-flex: 1
    -webkit-flex: 1 0 auto
    -ms-flex: 1 0 auto
    flex: 1 0 auto
    display: -webkit-box
    display: -webkit-flex
    display: -ms-flexbox
    display: flex
    -webkit-box-orient: vertical
    -webkit-box-direction: normal
    -webkit-flex-direction: column
    -ms-flex-direction: column
    flex-direction: column
    background-color: #fff
    margin-bottom: 16px
    padding: 5px 0

  .l-level__left
    margin: 0
    width: 108px
    height: 108px
    text-align: center

  .icon
    margin: auto

  .l-level__right
    padding: 16px

</style>



// WEBPACK FOOTER //
// BoxInfo.vue?55693ea6